import { NighthauntSlasherHost } from "./NighthauntSlasherHost";
import type { SpearheadArmy } from "./rules";
import { StormcastEternalsVigilantBrotherhood } from "./StormcastEternalsVigilantBrotherhood";
import { StormcastEternalsYndrastaSpearhead } from "./StormcastEternalsYndrastaSpearhead";

export * from "./NighthauntSlasherHost";
export * from "./rules";
export * from "./StormcastEternalsVigilantBrotherhood";
export * from "./StormcastEternalsYndrastaSpearhead";

export const SpearheadArmies = {
  nh_sh: NighthauntSlasherHost,
  se_vb: StormcastEternalsVigilantBrotherhood,
  se_ys: StormcastEternalsYndrastaSpearhead
} satisfies { [key: string]: SpearheadArmy };

export type SpearheadArmyId = keyof typeof SpearheadArmies;
export const SpearheadArmyId = Object.keys(SpearheadArmies) as SpearheadArmyId[];
